<template>
  <div class="common-carousel">
    <div
      class="carousel-track"
      :class="{ 'carousel-track--reverse': direction === 'right' }"
      :style="trackStyle"
    >
      <!-- 原始列表 -->
      <div
        v-for="(item, index) in items"
        :key="`a-${index}`"
        class="carousel-item"
        :style="itemGapStyle"
      >
        <slot name="item" :item="item" :index="index" />
      </div>
      <!-- 复制一份用于无缝衔接 -->
      <div
        v-for="(item, index) in items"
        :key="`b-${index}`"
        class="carousel-item"
        :style="itemGapStyle"
      >
        <slot name="item" :item="item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint } from '@rendora/design/index';

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);

const props = defineProps<{
  items: Array<any>;
  scrollSpeed?: number;
  direction?: 'left' | 'right';
}>();

const spaceBetween = computed(() => (isMobile.value ? 16 : 32));

// 动画时长：items 越多越慢，保持匀速感
const animationDuration = computed(() => {
  const baseSpeed = props.scrollSpeed ?? 4000;
  // 每个 item 滚过的时间 × item 数量 = 一组完整列表滚完的时间
  return (baseSpeed * props.items.length) / 1000;
});

const trackStyle = computed(() => ({
  animationDuration: `${animationDuration.value}s`,
}));

const itemGapStyle = computed(() => ({
  marginRight: `${spaceBetween.value}px`,
}));
</script>

<style lang="scss" scoped>
.common-carousel {
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  width: max-content;
  animation: scroll-left var(--duration, 40s) linear infinite;
  will-change: transform;

  &:hover {
    animation-play-state: paused;
  }

  &--reverse {
    animation-name: scroll-right;
  }
}

.carousel-item {
  flex-shrink: 0;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
